import { C } from "@/brand/tokens";

/**
 * ChamberChrome — the brass-ruled threshold rail that appears at the top
 * of every chamber. Establishes the page as a curated document spread
 * rather than a stack of marketing sections.
 *
 *   ┌───────────────────────────────────────────────────────────────┐
 *   │  II. — RECOGNITION · WHO WE HELP            FOUR PATTERNS      │
 *   └───────────────────────────────────────────────────────────────┘
 *
 * tone:
 *   - "dark"   — for Smoked Ink / Deep Mineral Blue chambers
 *   - "light"  — for Dry Stone / Soft Parchment chambers
 *
 * tint:
 *   Optional translucent darkening of the chrome strip so the rail
 *   pops slightly from the chamber's surface (used on the dark fields).
 */
export function ChamberChrome({
  numeral,
  title,
  category,
  meta,
  tone = "dark",
  tint = true,
}) {
  const isDark = tone === "dark";
  const textColor = isDark ? C.whiteOnDark : C.inkOnLight;
  const ruleColor = isDark ? C.brassLine : C.accentMetal;
  const dotColor = isDark ? C.brassLine : C.accentMetal;

  const tintBg = !tint
    ? "transparent"
    : isDark
    ? "rgba(22,24,27,0.18)"
    : "rgba(168,138,87,0.06)";

  return (
    <div
      className="border-b"
      style={{
        borderColor: C.brassSoft,
        background: tintBg,
      }}
    >
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-14 py-4 flex items-center justify-between gap-4">
        <div
          className="flex items-center gap-3 sm:gap-5 font-inter text-[10px] sm:text-[10.5px] uppercase font-semibold tabular-nums"
          style={{ color: C.accentMetal, letterSpacing: "0.28em" }}
        >
          <span>{numeral}</span>
          <span
            aria-hidden="true"
            className="inline-block h-px w-6"
            style={{ background: ruleColor }}
          />
          <span style={{ color: textColor }}>{title}</span>
          {category && (
            <>
              <span aria-hidden="true" style={{ color: dotColor }}>
                ·
              </span>
              <span style={{ color: textColor }}>{category}</span>
            </>
          )}
        </div>
        {meta && (
          <div
            className="font-inter text-[10px] sm:text-[10.5px] uppercase font-semibold tabular-nums hidden sm:inline whitespace-nowrap"
            style={{ color: ruleColor, letterSpacing: "0.32em" }}
          >
            {meta}
          </div>
        )}
      </div>
    </div>
  );
}
